<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <div class="search onsip-grid-placement">
    <div class="search-member-column">
      <mat-form-field appearance="outline">
        <input
          [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_SEARCH_USER"
          matInput
          [formControl]="searchMember"
          placeholder="Search"
          autocomplete="off"
        />
        <mat-icon matSuffix color="primary">search</mat-icon>
      </mat-form-field>
    </div>
    <div class="member-type-column">
      <mat-form-field appearance="outline">
        <mat-select [formControl]="memberType">
          @for (type of memberTypes; track type) {
          <mat-option [value]="type">
            {{ type | invokeFunction : selectMemberType }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <span class="members-count-column">
      <span class="mat-body-1">{{ members.value.length }}/{{ maxItemCount }}</span>
      <span class="members-count">members selected</span>
    </span>
  </div>
  <div class="group-members-table-wrapper">
    <onsip-select-member-drag-drop
      [formControl]="members"
      [isEditComponent]="true"
      [searchData]="searchMember.value"
      [filterData]="memberType.value"
      [maxItem]="maxItemCount"
    ></onsip-select-member-drag-drop>
    <div class="info">
      *A group is limited to 10 members and 24 device registrations. Individual group members can
      have multiple device registrations.
    </div>
  </div>
  <div class="page-view-controls">
    <button mat-button color="primary" class="cancel" type="button" (click)="cancel()">
      {{ "ONSIP_I18N.CANCEL" | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="onSubmit()"
      [attr.data-cy]="E2eLocators.ADMIN_GROUP_EDIT_SHELVE_MEMBERS_SUBMIT"
    >
      {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
    </button>
  </div>
</onsip-loading-container>
